import { faListCheck } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { BoxV4, NoteColors, NoteV2 } from '@labrav/react-components'
import {
  MicrosoftFormFAQs,
  MicrosoftFormFAQsItem,
} from '../MicrosoftFormFAQs/MicrosoftFormFAQs'
import { useStyles } from './BuyerNotification.styles'
import { BuyerNotificationForm } from '../../../../common/components/BuyerNotificationForm/BuyerNotificationForm'
import { FormikProps, useFormikContext } from 'formik'

export const BuyerNotification = () => {
  const { classes } = useStyles()
  const formikProps = useFormikContext() as FormikProps<Record<string, unknown>>
  return (
    <div data-testid="Contract-duration-section">
      <BoxV4
        heading={'Buyer notification'}
        headingIcon={
          <FontAwesomeIcon
            icon={faListCheck}
            style={{ width: '16px', height: '16px' }}
          />
        }
        isOptional
        secondaryActions={
          <MicrosoftFormFAQs item={MicrosoftFormFAQsItem.BUYER_NOTIFICATION} />
        }
      >
        <div className={classes.sectionContainer}>
          <NoteV2
            backgroundColor={NoteColors.BLUE}
            description={
              'Enter buyer details to send automated email reminders nudging buyer to complete offer acceptance, purchase, and account configuration before expiry. If left blank, Labra will not send any reminders.'
            }
          />
          <div className={classes.heading}>Buyer details</div>
          <BuyerNotificationForm formik={formikProps} deleteVisibeForAll />
        </div>
      </BoxV4>
    </div>
  )
}
